export enum NavigationToRewardPage {
    OnboardingAfterPurchaseNutritionistConsult = "onboarding-after-purchase-nutritionist-consult",
    OnboardingNoPurchase = "onboarding-no-purchase",
    Login = "login",
}